import { render } from "./DrumSettings.vue?vue&type=template&id=804e7ec4"
import script from "./DrumSettings.vue?vue&type=script&lang=js"
export * from "./DrumSettings.vue?vue&type=script&lang=js"

import "./DrumSettings.vue?vue&type=style&index=0&id=804e7ec4&lang=scss"

import exportComponent from "C:\\Users\\cheew\\OneDrive\\Desktop\\CE4172\\drum\\drum-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__